import ENDPOINTS from "@/configs/endpoints";
import api from "./api/axiosInstance";

export async function fetchAgentStatuses(): Promise<any> {
    const { data } = await api.get(ENDPOINTS.HTTP.AGENT_STATUS_LIST);
    return data?.data;
}

export async function updateAgentStatus(payload: { agentId: number; domainCode: string; sessionId: string; status: string }): Promise<boolean> {
    const { data } = await api.post(ENDPOINTS.HTTP.AGENT_STATUS_UPDATE, payload);
    return data.status === 'SUCCESS';
}

export async function updatePassword({ currentPassword, newPassword }: { currentPassword: string; newPassword: string }): Promise<boolean> {
    try {
        const response = await api.post(ENDPOINTS.HTTP.CHANGE_PASSWORD, {
            currentPassword: currentPassword,
            newPassword: newPassword
        });

        console.log(response, "password change response");

        // Check if response has codeId and it's not 1200 (success)
        if (response.data?.codeId && response.data?.codeId !== 1200) {
            // Throw error with API message
            const errorMessage = response.data?.message || "Failed to update password. Please try again.";
            throw new Error(errorMessage);
        }

        return response.status === 200 || response.data?.codeId === 1200;
    } catch (error: any) {
        // Extract error detail from API response
        const errorDetail = error.response?.data?.message || error.response?.data?.detail || error.message || "An error occurred while updating password.";
        throw new Error(errorDetail);
    }
}

export async function fetchAgentChats(domainCode: string, agentId: number, pageNo: number = 1, pageSize: number = 20, channel?: string): Promise<any> {
    const payload: any = {
        domainCode,
        agentId,
        pageNo,
        pageSize
    };
    if (channel && channel !== "ALL") {
        payload.channel = channel;
    }
    const { data } = await api.post(ENDPOINTS.HTTP.AGENT_CHAT_HISTORY, payload);
    return data?.data;
}

export async function fetchAgentChatsByChatId(domainCode: string | null, chatId: string, pageNo: number = 1, pageSize: number = 20): Promise<any> {
    const { data } = await api.post(ENDPOINTS.HTTP.AGENT_CHAT_BY_CHATID, {
        domainCode,
        chatId,
        pageNo,
        pageSize
    });
    return data?.data;
}

export async function logoutUser(userLoginInfo: number, sessionAvailable: boolean): Promise<boolean> {
    const { data } = await api.post(ENDPOINTS.HTTP.LOGOUT, {
        loginInfoId: userLoginInfo,
        sessionAvailable
    });
    return data?.status === "SUCCESS";
}


